import React, { useState, useEffect } from "react";
import RetailerFitGuide_ProductListItem from "../Shared/RetailerFitGuide_ProductListItem.jsx";
import { useAppState } from "../RetailerFitGuide_StateContext.jsx";
import { track_tabClick } from "../Script/RetailerFitGuide_Tracking.js";
import { TRACK_EVENT_TYPE } from "../Script/RetailerFitGuide_Constants.js";
const RetailerFitGuide_CompatibleProducts = ({ fittingProductCategories }) => {
    const [selectedProductCategory, setSelectedProductCategory] = useState();
    const [productsResponse, setProductsResponse] = useState();

    const allFittingProducts = fittingProductCategories?.flatMap(category => category.Products || [])
        .reduce((acc, product) => {
            if (!acc[product.productId]) {
                const caprockAdapterInfo = product.caprockAdapter ? JSON.parse(product.caprockAdapter) : null;
                let adapter;
                if (caprockAdapterInfo && caprockAdapterInfo.Value === "YesWith" && caprockAdapterInfo?.Adapters?.length > 0) {
                    adapter = caprockAdapterInfo?.Adapters[0];
                }else if(product.category === "Platform"){ // Yes - for platform category 611300 is always required
                    adapter = {WebTitle1: "Thule Caprock crossbar kit", ThuleSKUNo: "611300"};
                }
                acc[product.productId] = { ...product, adapter };
            }
            return acc;
        }, {});

    const {
        translations,
    } = useAppState();

    useEffect(() => {
        if (fittingProductCategories && fittingProductCategories.length > 0) {
            setSelectedProductCategory(fittingProductCategories[0]);
            loadList();
        }

    }, [fittingProductCategories]);

    const loadList = () => {
        let productIds = [];
        fittingProductCategories.forEach(productCategory => {
            if (!productCategory?.Products?.length)
                return;
            productCategory.Products.forEach(product => {
                if (productIds.includes(product.productId))
                    return;
                productIds.push(product.productId);
            });
        });

        const products = productIds.map((x) => ({ ProductId: x, Quantity: 1 }));
        const payload = {
            productsInput: products,
            additionalData: false
        };

        fetch("/api/sitecore/fitguide/GetRetailerFitGuideProductListData", {
            method: "POST",
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data?.ListProducts?.length) {
                    const products = data.ListProducts.reduce((acc, item) => {
                        acc[item.ProductId] = { ...item, ...allFittingProducts[item.ProductId] };
                        return acc;
                    }, {});
                    setProductsResponse({ TotalPriceFormatted: data.TotalPriceFormatted, Products: products });
                }
            })
            .catch(error => console.error("Error:", error));
    }

    const onClickCategoryButton = (productCategory) => {
        setSelectedProductCategory(productCategory);
        track_tabClick(productCategory.Name, TRACK_EVENT_TYPE.CARFIT);
    }

    return (
        <>
            <div className="rfg_compatibleProducts">
                <h2 className="heading4 mb-7">{translations?.compatibleProducts}</h2>

                {fittingProductCategories?.length > 0 ? <>
                    <div className="tabMenu mb-7 scrollBar--0">
                        {fittingProductCategories.map((productCategory, index) => {
                            return (
                                <button
                                    key={index}
                                    onClick={() => {
                                        onClickCategoryButton(productCategory);
                                    }}
                                    className={`btn paragraph tabMenuButton heading6 ${selectedProductCategory && productCategory.Name == selectedProductCategory.Name && 'active'}`}>
                                    {productCategory.Name}
                                </button>
                            );
                        })}
                    </div>
                    {selectedProductCategory && (
                        <ul className="rfg_productGroup">
                            {selectedProductCategory.Products &&
                                selectedProductCategory.Products.map((product, index) => {
                                    return (
                                        <RetailerFitGuide_ProductListItem trackingType={TRACK_EVENT_TYPE.COMPATIBLEPRODUCTS} showAddToCartButton={true} key={index} productListItem={productsResponse?.Products[product.productId]} />
                                    );
                                })}
                        </ul>
                    )}
                </> : <p className="paragraph">{translations?.noCompatibleProducts}.</p>}
            </div>
        </>
    );
};
export default RetailerFitGuide_CompatibleProducts;